<template>
  <div class="row">
    <work-menu></work-menu>
    <div class="col-md-10 pt-3" v-if="hasAnyRole('ROLE_ADMIN','ROLE_WORK_READ','ROLE_WORK_ADMIN')">
      <div>
          <div class="form-group">
              <span>年</span>
              <select class="search-select custom-select mr-1" name="year" v-model="selectedYear" @change="changeSelected">
                  <option v-for="year in yearList" :value="year" :key="year">
                          {{year}}
                  </option>
              </select>
              <span>月</span>
              <select class="search-select custom-select mr-1" name="month" v-model="selectedMonth" @change="changeSelected">
                  <option v-for="month in 12" :value="month" :key="month">
                          {{month}}
                  </option>
              </select>
              <span>部署</span>
              <select class="search-select custom-select mr-1" name="department" v-model="selectedDepartmentId" @change="changeSelected">
                  <option value="" selected="selected" v-if="hasAnyRole('ROLE_ADMIN', 'ROLE_MANAGE')">すべて</option>
                  <option v-for="(current, index) in loginUser.departmentList" :value="loginUser.departmentIdList[index]" :key="index">
                          {{current}}
                  </option>
              </select>
              <a :href="'/api/work/download/' + selectedYear + '/' + selectedMonth + '/excel?departmentId=' + selectedDepartmentId">
                <button type="button" class="btn btn-info" style="border-radius: 50px;">
                    <i class="fas fa-cloud-download-alt fa-1x" aria-hidden="true"></i>全員分ダウンロード
                </button>
              </a>
              <label ref="viewAll"><input type="checkbox" id="viewAll" @click="checkUserView">退職者も表示</label>
          </div>
      </div>
      <div v-if="monthlySummaryList.length == 0">まだレコードはありません</div>
      <div v-else>
        <table class="table table-sm table-bordered table-responsive">
            <thead class="thead-light">
            <tr>
                <th>氏名</th>
                <th>ステータス</th>
                <th>シフト名</th>
                <th>部署名</th>
                <th>出勤数</th>
                <th>遅刻数</th>
                <th>早退数</th>
                <th>出勤時間</th>
                <th>休憩時間</th>
                <th>その他休憩</th>
                <th>深夜帯休憩</th>
                <th>実働時間</th>
                <th>残業時間</th>
                <th>深夜帯時間</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="result in monthlySummaryList" :key="result.userId" v-if="viewAll || result.deletedAt == null" :class="{'retiree': result.deletedAt}">
                    <td class="noflap">
                        <img class="card-img-top icon" :src="result.imageUrl ? result.imageUrl : ''" onerror="this.src='/src/assets/img/not_found_user_icon.jpg';">
                        <a :href="'/admin/work/detail/' + result.userId + '?year=' + selectedYear + '&month=' + selectedMonth">{{result.userName}}</a>
                    </td>
                    <td class="text-center">
                        <div class="mb-1" v-if="result.hasAttachment == true">
                            <a :href="'/api/work/timetable/upload/' + selectedYear + '/' + selectedMonth + '/' + result.userId">
                                <button type="button" class="btn btn-info" style="-webkit-border-radius: 24px,0 -moz-border-radius: 24px,0;">添付あり</button> 
                            </a>
                        </div>
                        <div class="square_btn" v-if="result.approvedCount ==　result.days">承認</div>
                        <div class="square_btn1" v-else-if="result.confirmCount == result.days"> 確定</div>
                        <div class="square_btn2" v-else-if="result.remandRecuestCount == result.days"> 差戻中</div>
                        <div v-else-if="result.approvedCount != result.days">未確定</div>
                    </td>
                    <td>{{result.shiftName}}</td>
                    <td >{{ result.unit && result.unit.length > 10 ? result.unit.slice(0,10) + '...' : result.unit }}</td>
                    <td class="text-right">{{result.workCount}}</td>
                    <td class="text-right">{{result.lateCount}}</td>
                    <td class="text-right">{{result.leaveEarlyCount}}</td>
                    <td class="text-right">{{result.officeHourSum}}</td>
                    <td class="text-right">{{result.breakTimeSum}}</td>
                    <td class="text-right">{{result.otherBreakTimeSum}}</td>
                    <td class="text-right">{{result.midnightBreakTimeSum}}</td>
                    <td class="text-right" style="background: aliceblue">{{result.workHourSum}}</td>
                    <td class="text-right" style="background: aliceblue">{{result.overHourSum}}</td>
                    <td class="text-right" style="background: aliceblue">{{result.midnightHourSum}}</td>
                </tr>
            </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
.noflap{
 white-space: nowrap;
}
.retiree{
  background: #ccc;
}
.icon {
  border-radius: 50%;
  height: 45px;
  width: 45px;
}
.square_btn {
    display: inline-block;
    padding: 0.3em 1em;
    text-decoration: none;
    color: rgb(201, 22, 9);
    border: solid 1px rgb(201, 22, 9);
    border-radius: 5px;
    -webkit-border-radius: 5px;    /* Safari,Google Chrome用 */  
    -moz-border-radius: 5px; 
    transition: .4s;
}

.square_btn1 {
    display: inline-block;
    padding: 0.3em 1em;
    text-decoration: none;
    color: rgb(10, 95, 143);
    border: solid 1px rgb(10, 95, 143);
    border-radius: 5px;
    -webkit-border-radius: 5px;    /* Safari,Google Chrome用 */  
    -moz-border-radius: 5px; 
    transition: .4s;
}

.square_btn2 {
    display: inline-block;
    padding: 0.3em 1em;
    text-decoration: none;
    color: rgb(30, 44, 31);
    border: solid 1px rgb(30, 44, 31);
    border-radius: 5px;
    -webkit-border-radius: 5px;    /* Safari,Google Chrome用 */  
    -moz-border-radius: 5px; 
    transition: .4s;
}
</style>

<script>
import WorkAPI from '../../../api/work-api'
import CommonAPI from '../../../api/common-api'
import moment from 'moment'
import WorkMenu from './WorkMenu.vue'

export default {
  name: "work-monthly-summary",
  components: {
    WorkMenu,
  },
  data() {
    return {
      loading: true,
      loginUser: {
        role: ''
      },
      yearList: [],
      monthlySummaryList: [],
      selectedYear: moment().format("YYYY"),
      selectedMonth: moment().format("M"),
      selectedDepartmentId: '',
      viewAll: false,
    }
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
        this.loginUser = this.$root.$refs.asnHeader.$data.loginUser
        if(!this.hasAnyRole('ROLE_ADMIN', 'ROLE_MANAGE')){
            this.selectedDepartmentId = this.loginUser.departmentIdList.length > 0 ? this.loginUser.departmentIdList[0] : ''
        }
    },
  },
  mounted () {
    if (this.$route.query.year) {
        this.selectedYear = this.$route.query.year
    }
    if (this.$route.query.month) {
        this.selectedMonth = this.$route.query.month
    }
    if (this.$route.query.departmentId){
        this.selectedDepartmentId = this.$route.query.departmentId;
    }
    this.getWorkList()
    this.getYearList()
  },
  methods: {
    // 年一覧取得
    getYearList () {
      WorkAPI.getYearList()
        .then(res => {
            this.yearList = res
        })
        .catch(err => {
            console.error(err)
        })
    },
    // 勤怠一覧取得
    getWorkList () {
      this.$root.$refs.loading.$data.show = true
      let params = {}
      params['year'] = this.selectedYear
      params['month'] = this.selectedMonth
      params['departmentId'] = this.selectedDepartmentId
      WorkAPI.getMonthlySummary(params)
        .then(res => {
            this.monthlySummaryList = res
            this.$nextTick(function() {
                this.$root.$refs.loading.$data.show = false
                this.getAttachment()
            })
        })
        .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
        })
    },
    // 添付ファイル取得
    getAttachment(){
        WorkAPI.isExistsUploadByDepartment(this.selectedYear, this.selectedMonth, this.selectedDepartmentId)
            .then(res => {
                console.log(res)
                res.forEach(function(current){
                    if(current.isExists){
                        this.monthlySummaryList.forEach(function(summary){
                            if(current.userId == summary.userId){
                                summary.hasAttachment = true
                            }
                        })
                    }
                }.bind(this))
            })
            .catch(err => {
                console.error(err)
                this.$root.$refs.loading.$data.show = false
            })
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    },
    // 退職者も表示
    checkUserView() {
      this.viewAll = !this.viewAll
    },
    // セレクト変更時
    changeSelected () {
        // 履歴を追加
        this.$router.push("/admin/work/top/?year=" + this.selectedYear
        + "&month=" + this.selectedMonth 
        + "&departmentId=" + this.selectedDepartmentId)
        // データの再取得
        this.getWorkList()
    },
  },
  filters: {
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/admin/work/WorkMonthlySummary.vue